export default {
    KEYNOTE: "Keynote/Fireside Chat",
    PRESENTATION: "Presentation",
    ROUNDTABLE: "Roundtable",
    //DEMO: "DEMO",
    CERTIFICATE: "Panels",
    SIMULATIONS: "Simulations",
  };
  